
import React, { useEffect } from 'react';

import AppStateVisual from './components/AppStateVisual';

import Header from './components/Header';

import ChatHead from './components/ChatHead';
import AppBody from './components/AppBody';

import Footer from './components/Footer';

import { SessionContextProvider } from './context/SessionContext';
import { NotificationContextProvider } from './context/NotificationContext';
import { ProfileContextProvider } from './context/ProfileContext';
import { PromptContextProvider } from './context/PromptContext';
import { AdminContextProvider } from './context/AdminContext';

import { AdminToggle } from './components/AdminPanel';

import { APP, AI4YOUTH, ENRICHYA } from './common/constants';




function App() {

  useEffect(() => {
    // Set dynamic page title based on app constant
    const appName = APP === AI4YOUTH ? 'AI4Youth' : APP === ENRICHYA ? 'Enrichya' : 'AI4Youth';
    document.title = `${appName} Session`;
  }, []);

  return (
    <div className="">
      <NotificationContextProvider>
        <SessionContextProvider>
          <ProfileContextProvider>
            <PromptContextProvider>
              <AdminContextProvider>
                <AdminToggle />

                <AppStateVisual />

                <Header />

                <ChatHead />

                <AppBody />

                <Footer />
              </AdminContextProvider>
            </PromptContextProvider>
          </ProfileContextProvider>
        </SessionContextProvider>
      </NotificationContextProvider>
    </div>
  );
}

export default App;
